import { apiPost, baseApi, options, response } from "@dex/bubl-fetch";

const endpoint = 'Pages';

const PagesApi: any = baseApi(endpoint);

export default PagesApi;